//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickOutside() {
      this.$emit('input', false);
    },
    close() {
      this.$emit('input', false);
    },
  },
};
